<span class="created-by">
    {{ 'footer.created' | translate }} <b><a href="https://vistingo.com" target="_blank">Vistingo</a></b> {{ currentYear }}
</span>
<div class="socials">
    <a href="https://www.linkedin.com/company/vistingo" target="_blank" class="ion ion-social-linkedin"></a>
</div>